export enum DateSelectionType {
    Date = 'Date',
    CellReference = 'Cell Reference'
}

export enum CurrencySelectionType {
    Value = 'Currency',
    CellReference = 'Cell Reference'
}

export enum BaseCurrencySelectionType {
    Value = 'Value',
    CellReference = 'Cell Reference'
}

export enum QuoteCurrencySelectionType {

    Value = 'Value',
    CellReference = 'Cell Reference'
}

export enum CompanyIdentificationType {
    Search = 'Search',
    CellReference = 'Cell Reference'
}

export enum CurrencyPlaceholderName {
    BaseCurrencyCellReference = "BASE_CURRENCY_CELL_REFERENCE",
    QuoteCurrencyCellReference = "QOUTE_CURRENCY_CELL_REFERENCE",
    DateCellReference = "DATE_CELL_REFERENCE",
    FormulaLocationCellReference = "FORMULA_LOCATION_CELL_REFERENCE"
}

export enum EquityPlaceholderName {
    CompanyIdentificationExchangeCellReference = "COMPANY_IDENTIFICATION_EXCHANGE_CELL_REFERENCE",
    CompanyIdentificationTickerCellReference = "COMPANY_IDENTIFICATION_TICKER_CELL_REFERENCE",
    CurrencyCellReference = "CURRENCY_CELL_REFERENCE",
    DateCellReference = "DATE_CELL_REFERENCE",
    FormulaLocationCellReference = "FORMULA_LOCATION_CELL_REFERENCE",
    BeginningDateCellReference = "BEGINNING_DATE_CELL_REFERENCE",
    EndingDateCellReference = "ENDING_DATE_CELL_REFERENCE",
}

export enum CompanyPlaceholderName {
    CompanyIdentificationExchangeCellReference = "COMPANY_IDENTIFICATION_EXCHANGE_CELL_REFERENCE",
    CompanyIdentificationTickerCellReference = "COMPANY_IDENTIFICATION_TICKER_CELL_REFERENCE",
    FormulaLocationCellReference = "FORMULA_LOCATION_CELL_REFERENCE",
    CurrencyCellReference = "CURRENCY_CELL_REFERENCE",
}

export enum TradedFundsPlaceholderName {
    DateCellReference = "DATE_CELL_REFERENCE",
    CurrencyCellReference = "CURRENCY_CELL_REFERENCE",
    FormulaLocationCellReference = "FORMULA_LOCATION_CELL_REFERENCE",
    FundIdentificationExchangeCellReference = "FUND_IDENTIFICATION_EXCHANGE_CELL_REFERENCE",
    FundIdentificationTickerCellReference = "FUND_IDENTIFICATION_TICKER_CELL_REFERENCE"
}

export enum CapitalizationActualsPlaceholderName {
    CompanyIdentificationExchangeCellReference = "COMPANY_IDENTIFICATION_EXCHANGE_CELL_REFERENCE",
    CompanyIdentificationTickerCellReference = "COMPANY_IDENTIFICATION_TICKER_CELL_REFERENCE",
    FormulaLocationCellReference = "FORMULA_LOCATION_CELL_REFERENCE"
}

export enum CustomBuiltIndexPlaceholderName {
    InputRangeCellReference = "INPUT_RANGE_CELL_REFERENCE",
    DateCellReference = "DATE_CELL_REFERENCE",
    FormulaLocationCellReference = "CUSTOM_BUILT_INDEX_FORMULA_LOCATION_CELL_REFERENCE"
}

export enum TIndexLookUpApproach {
    RecommendationTool = 'recommendationTool',
    SearchByFundName = 'searchByFundName',
    CellReference = 'cellReference',
}

export enum TRecommendationType {
    Niche = 'niche',
    Market = 'market',
    Sector = 'sector',
}

export interface TradedFundFilters {
    fundType: string;
    region: string;
    maxResults: number;
}

export interface DateValue {
    selected: DateSelectionType;
    date?: string;
    dateCellReference?: string;
    beginDate?: string;
    endDate?: string;
    beginDateCellReference?: string;
    endDateCellReference?: string;
}

export interface BaseCurrencyValue {
    selected: BaseCurrencySelectionType;
    currency?: string;
    currencyCellReference?: string;
}

export interface QuoteCurrencyValue {
    selected: QuoteCurrencySelectionType;
    currency?: string;
    currencyCellReference?: string;
}
export interface CurrencyValue {
    selected: CurrencySelectionType;
    currency?: string;
    currencyCellReference?: string;
}

export interface CompanyIdentificationValue {
    selected: CompanyIdentificationType;
    searchInput?: string;
    exchange?: string;
    ticker?: string;
}

export interface TradedFundsIdentification {
    selected: TIndexLookUpApproach;
    index?: string;
    exchange?: string;
    ticker?: string;
}

export interface TradedFundsIdentificationValue {
    index?: string;
    date: DateValue;
    currency: CurrencyValue;
}

export interface NewLinkBuilderFormData {
    companyIdentification: CompanyIdentificationValue;
    date: DateValue;
    currency: CurrencyValue;
    formulaLocation: string;
}

export enum TFundType {
    Index = 'index',
    ETF = 'etf',
    // MutualFund = 'mutual_fund',
}

export const FUND_TYPE_OPTIONS: ReadonlyArray<{ value: TFundType; label: string }> = [
    { value: TFundType.Index, label: 'Index' },
    { value: TFundType.ETF, label: 'ETF' },
    // { value: TFundType.MutualFund, label: 'Mutual Fund' },  
];